import React, { useId } from 'react'

const Popover = ({ trigger, children, align = 'left' }) => {
  const popoverId = useId()
  const anchorName = `--anchor-${popoverId.replace(/:/g, '')}`;

  return (
    <>
      <button popovertarget={popoverId} className="popover-trigger-reset" style={{ anchorName: anchorName }}>
        {trigger}
      </button>

      <div id={popoverId} popover="auto" className={`popover-panel align-${align}`} style={{ positionAnchor: anchorName }}>
        <div className="popover-inner">
          {children}
          {/* <button popovertarget={popoverId} popovertargetaction="hide" className="close-btn"></button> */}
        </div>
      </div>
    </>
  );
};

export default Popover;